<template>
  <div>
    
      <div>
      
    <v-layout class = "mr-5 mt-4">

      <h1 style="margin-left :15px"> <v-icon>mdi-account-tie</v-icon> Guest User</h1>
      <v-spacer></v-spacer>
      <v-text-field label = "Search" v-model = "searchUser"></v-text-field>
      <v-spacer></v-spacer>
      <v-btn @click = "openDialog()" rounded outlined> <v-icon>mdi-account-plus</v-icon>  Add New Guest </v-btn>
    </v-layout>
  </div>
  <v-container fluid>
      
          <v-container fluid>
    
              <v-data-table
              :headers="headers"
              :items="search"
              :items-per-page="15"
              class="elevation-1">
                <!-- <template v-slot:body="{ items }">
                  <tbody>
                      <tr 
                      :bgcolor="editIndex === i ? '#e6eeff': ''" 
                      @click="getRecords(item, i)" 
                      >
                      </tr>
                  </tbody>
              </template> -->
              <template v-slot:item.details="{ item }">
              <v-btn @click="editRec(item)" elevation="0" x-small fab>
                      <v-icon color="grey darken-1">mdi-pencil</v-icon>
                  </v-btn>
                  <!-- <v-btn @click="deleteRec(item,item.id)" elevation="0" x-small fab>
                      <v-icon color="grey darken-1">mdi-trash-can-outline</v-icon>
                  </v-btn> -->
              </template>
              
              </v-data-table>
    
  


      </v-container>
      
    </v-container>

    <v-dialog v-model = "dialog" persistent width="700px">
    <v-card>
      <v-form ref="form" v-model="valid" :lazy-validation="lazy">
        <v-toolbar dense color="#213c57" dark>
          <span style = "font-family: Verdana;font-size:15px"> Guest Information</span>
          <v-spacer></v-spacer>
            <v-btn icon @click = "closeDialog"><v-icon>mdi-close</v-icon></v-btn>
        </v-toolbar>
        <v-card-text>
          
            <v-layout>
              <v-row>
                  <v-col cols="12" sm="6">
                    <v-text-field v-model="toAdd.id" required outlined label = "Employee ID" dense :rules="rules1" oninput="this.value = this.value.toUpperCase()"></v-text-field>

                    <v-text-field v-model="toAdd.LastNameEng" required outlined label = "Last Name" dense :rules="rules2" oninput="this.value = this.value.toUpperCase()"></v-text-field> 
                    
                    <v-text-field v-model="toAdd.localNumber" outlined label = "Local Number" dense ></v-text-field>
                      <v-select v-model="toAdd.PickUpPoint" :items = "PickUpPointList" dense outlined label = "Pick Up Point" :rules="rules9"></v-select>
                      <!-- <v-select v-model="toAdd.category" required :items = "categorylist" dense outlined label = "Category" :rules="rules5"></v-select> -->
                      <v-select v-model="toAdd.gender" :items="gender" dense outlined label="Gender" :rules="rules11"></v-select>
                    </v-col>

                  
                  <v-col cols="12" sm="6" >
                    <v-spacer></v-spacer>
                      <v-select v-model="toAdd.Status" required :items = "available" dense outlined label = "Status" :rules="rules6"></v-select>
                      <v-text-field v-model="toAdd.FirstNameEng" required outlined label = "First Name" dense :rules="rules3" oninput="this.value = this.value.toUpperCase()"></v-text-field>
                      <v-text-field v-model="toAdd.cellphoneNumber" outlined label = "Cellphone Number" dense ></v-text-field>  
                      <v-select v-model="toAdd.DropPoint" dense outlined label="Drop Point" :items="AreaList" :rules="rules10"></v-select>
                      <v-select v-model="toAdd.DropPointDetails" :items = "newDropPointList" dense outlined label = "Drop Point Details" :rules="rules8"></v-select>
                    
                  </v-col>
                </v-row>
            </v-layout>
             
          <v-layout>
          <v-text-field
                label="Email Address"
                v-model="toAdd.WorkMailAdd"
                required
                dense
                outlined
                 :rules="emailRules"
                 :readonly="isEditing"
              ></v-text-field>
          <v-spacer></v-spacer>
                  <v-btn
                      :disabled="!valid"
                      color="success"
                      rounded outlined
                      @click="addUser()"
                      > <v-icon>mdi-content-save</v-icon>
                      {{btnName}}
                  </v-btn>
              
          </v-layout>
            
          
        </v-card-text>
          </v-form>
    </v-card>
    </v-dialog>
  </div>
</template>

<script>

import moment from 'moment-timezone'
// import axios from 'axios'
import api from '../api.js'
import md5 from 'md5'
export default {
  components:{
      
  },
  created(){
  this.loaduserslist()
  this.profilePic = '../image/avatar/fbavatar.jpg'
  this.loadPickUpList()
  this.loadDropPointList()
  this.loadAreaList()
  },
  data(){
      return{
      isEditing: false,
      emailRules: [ // 2026-04-22
          v => !!v || 'E-mail is required',
          v => /.+@.+\..+/.test(v) || 'E-mail must be valid'
       ],
      searchUser: '',
      dialog: false,
      headers :[
        { text: 'Guest ID',align: 'left',value: 'id',},
        { text: 'Last Name', value: 'LastNameEng' },
        { text: 'First Name', value: 'FirstNameEng' },
        { text: 'Local Number', value: 'localNumber' },
        // { text: 'Category', value: 'category'},
        // { text: 'UserLevel', value: 'userLevel'},
        { text: 'Status', value: 'Status'},
        { text: 'Details',sortable: false, align:'center', value: 'details'}  
      ],
      userslist:[],
        AreaList:[],
        DropPointList:[],
      PickUpPointList:[],
        profilePic: '',
        available:['Active','Inactive'],
        categorylist:['REGULAR','GUEST'],
        userLevelList:['User','Admin','Driver'],
        toAdd:{},
        file: null,
        valid : false,
        lazy: false,
        rules1 : [
            v => !!v || 'Employee ID is required'
        ],
        rules2 : [
            v => !!v || 'Last Name is required'
        ],
        rules3 : [
            v => !!v || 'First Name is required'
        ],
      
        rules5 : [
            v => !!v || 'Category is required'
        ],
        rules6 : [
            v => !!v || 'Status is required'
        ],
        rules7:[
          v => !!v || 'User level is required'
        ],
        rules8:[
          v => !!v || 'Drop point details is required'
        ],
        rules9:[
          v => !!v || 'Pick up point is required'
        ],
        rules10:[
          v => !!v || 'Drop point is required'
        ],
        rules11:[
          v => !!v || 'Gender is required'
        ],
        searchRec: '',
        editIndex: -1,
        editedItem: {
          name: '',
          Contact: '',
          available: '',
        
        
        },
        btnName : '',
        dateToday : moment().format('YYYY-MM-DD'),
        toAddSoumu : {
          id: "",
          FirstNameEng: "",
          LastNameEng: "",
          Password : '',
          localNumber : '',
          phoneNumber : '',
          PickUpPoint : '',
          DropPoint: "",
          DropPointDetails: "",
          strGender : "",
          UpdatedBy : "00000" 
        },

        gender : [
          'Female', 'Male'
        ]

      }
  },
  methods: {
    openDialog(){
        this.dialog = true
        this.isEditing = false;
        this.btnName = 'Save'
      },
    closeDialog(){
        this.dialog = false
        this.toAdd ={}
    }, 

    async addUser() {  // 2026-04-22
      try {
        // 1. Calculate the password once to save resources
        const generatedPassword = md5(this.toAdd.id);

        if (this.btnName === 'Save') {
          
          // 2. AWAIT the Cognito registration
          const response = await api.post(`${this.api}auth/registerSingleUserInAWSCognitoUserPool`, {
            id: this.toAdd.id,
            Password: generatedPassword,
            WorkMailAdd: this.toAdd.WorkMailAdd
          });

          // 3. Set the payload property
          this.toAdd.isUseCARS = true;

          if( response.data.message != 'Email is already exists in Cognito Users pool') {
            // 4. AWAIT the database save
            const res = await api.post(`${this.api}addGuestUser`, this.toAdd);
            
            if (res.data) {
              console.log(res.data);
              alert('Successfully Saved'); // Added user feedback for Save
              this.loaduserslist();
            }
          }

          else{
            alert( response.data.message );
            this.loaduserslist();

          }
        } else {
          
          // Update Flow - AWAIT the database update
          const res = await api.put(`${this.api}updateGuestUser`, this.toAdd);
          
          if (res.data) {
            console.log(res.data);
            alert('Successfully Updated');
            this.loaduserslist();
          }
        }

        // 5. Close the dialog ONLY if everything above was successful
        this.closeDialog();

      } catch (error) {
        // 6. Catch and display errors (e.g., Cognito user already exists)
        console.error("Error processing user:", error);
        
        // Attempt to show the actual backend error message, fallback to generic
        const errorMsg = error.response.data.message || error.message || "An error occurred.";
        alert(`Failed to save: ${errorMsg}`);
      }
    },
    // async addUser(){  // 2026-04-22
    //   this.toAddSoumu = this.toAdd
    //   this.toAddSoumu.Password =  md5(this.toAdd.id) 
    //   this.toAddSoumu.strGender = this.toAdd.gender
    //   if (this.btnName === 'Save'){  

    //     const urlRegisterUserPool = `${this.api}auth/registerSingleUserInAWSCognitoUserPool`;
    //     await api.post( urlRegisterUserPool , {
    //        id: this.toAdd.id,
    //        Password: md5(this.toAdd.id),
    //        WorkMailAdd: this.toAdd.WorkMailAdd
    //     })


    //     let url = `${this.api}addGuestUser`
    //       this.toAdd.isUseCARS = true
    //       api.post(url, this.toAdd).then (res =>{
    //         if(res.data) {
    //             console.log(res.data)
    //             this.loaduserslist()
    //         }        
    //       } ) 

    //     }else{
    //       // Upload Record
    //       let url = `${this.api}updateGuestUser`

    //       api.put(url, this.toAdd).then (res =>{
    //         // this.employeedata = res.data
    //           if(res.data) {
    //             console.log(res.data)
    //             alert('Successfully Updated')
    //             this.loaduserslist()
    //           }     
      
    //       })
    //    }
    
    //    this.closeDialog()
    // },
    loaduserslist(){
         let url =  `${this.api}guest_users`
         api.get(url).then( res => {
          this.userslist = res.data 
         }) 
      },
      onFileChange(){
          this.myData.filename = Date.now() + "-" + this.file.name;
          this.myData.path = `./uploads/request_images/${this.myData.filename}`
          console.log(this.file)
          this.imageUrl = URL.createObjectURL(this.file);
      },
      getRecords(val, i){
          this.editIndex = i
          this.toAdd = val
      },

    deleteRec(rec,id) {
      console.log(id)
      const index = this.userslist.indexOf(rec)
        confirm('Are you sure you want to delete this User?') && 
      this.userslist.splice(index,1)
      let url = `${this.api}deleteUser`
      api.post(url,{id:id}).then( res => {
      console.log(res.data)
      this.loaduserlist()
      }
      )
      
    },

    editRec(rec){
        this.dialog = true
        this.isEditing = true;
        this.btnName = 'Update'
        this.toAdd = rec
    },

    loadPickUpList(){
        let url = `${this.api}getPickPoint`
        api.get(url).then(res =>{
          this.PickUpPointList = res.data.filter( rec =>{
          return rec.SelectUse == 'Yes'
          }).map( rec1 => {
          return rec1.PointName
          }).sort()
        })
      },

      loadDropPointList(){
        let url = `${this.api}getDropPoint`
        api.get(url).then(res =>{
          console.log('320',res.data)
          this.DropPointList = res.data
          // this.DropPointList = res.data.filter( rec =>{
          // return rec.SelectUse == 'Yes'
          // }).map( rec1 => {
          // return rec1.PointName
          // })
        })
        
      },
      loadAreaList(){
        let url = `${this.api}getDropPoint`
        api.get(url).then(res =>{
          this.AreaList = res.data.filter( rec =>{
          return rec.SelectUse == 'Yes'
          })
          .map( rec1 => {
          return rec1.PointNameArea
          })
        })
      }

      },
  

  computed:{


      search(){
        return this.userslist.filter( rec => {
          return rec.FirstNameEng.toLowerCase().includes(this.searchUser.toLowerCase()) || rec.EmployeeNumber === this.searchUser || rec.LastNameEng.toLowerCase().includes(this.searchUser.toLowerCase())
        })
      },

      newDropPointList(){

        if(this.toAdd.DropPoint == undefined || this.toAdd.DropPoint == '' ){
          return []
        }else{
          console.log(this.toAdd.DropPoint)
          return this.DropPointList.filter(r =>{
          return r.PointNameArea == this.toAdd.DropPoint
          }).map(rec =>{
            return rec.PointName
          })
        }
        
      }
  }
  

}
</script>

<style scoped>

table, td ,th {
border: 1px solid gray !important;
border-collapse: collapse !important;
}

table>thead>tr>th{
border: 1px solid gray !important;
padding: 5px !important;
font-size: 15px !important;
margin: 0px !important;
}

table>thead>tr{
padding: 0px !important;
/* background-color: !important; */
}
</style>

